'use client'
import { FC, useEffect, useState} from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, SliceZone } from "@prismicio/react";
import { components } from "@/slices";
import { createClient } from "@/prismicio";


/**
 * Props for `Campaign`.
 */
export type CampaignProps = SliceComponentProps<Content.CampaignSlice>;

/**
 * Component for "Campaign" Slices.
 */
const Campaign: FC<CampaignProps> = ({ slice }) => {

  const [campaignSlices, setCampaignSlices] = useState([]) as any
  
  useEffect(()=> {

    const getCampaign = async (slice: any)=>{
      const campaignId = slice?.primary?.campaign?.id
      if (!campaignId) {
        setCampaignSlices([])
        return
      }

      const client = createClient()
      const response = await client.getByID(campaignId) as any
  
      // console.log(response)
      setCampaignSlices(response.data.slices)
    }
  
    getCampaign(slice) as any

  }, [slice])

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className=""
    >
      {campaignSlices?.length > 0 ?
      <SliceZone slices={campaignSlices} components={components} />
      : <></>}
    </section>
  );
};

export default Campaign;
